(() => {
  // Reveal-on-scroll
  const els = document.querySelectorAll('.pc-reveal');
  if ('IntersectionObserver' in window && els.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((el) => io.observe(el));
  } else { els.forEach((el) => el.classList.add('is-in')); }

  // Quick add (pc-collection cards)
  document.addEventListener('click', async (ev) => {
    const btn = ev.target.closest('[data-pc-add]');
    if (!btn) return;
    ev.preventDefault();
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.dataset.adding || 'Adding';
    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.pcAdd), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      const cart = await (await fetch((window.Shopify?.routes?.root || '/') + 'cart.js')).json();
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'pc-quick-add', data: { source: 'pc-quick-add', itemCount: cart.item_count, variantId: btn.dataset.pcAdd } } }));
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      btn.classList.add('is-done');
      btn.textContent = btn.dataset.added || 'Added';
      setTimeout(() => { btn.textContent = label; btn.classList.remove('is-done'); btn.disabled = false; }, 2200);
    } catch (e) {
      window.location.href = btn.dataset.url;
    }
  });
  // Mobile sticky add-to-cart on product pages
  const initStickyAtc = () => {
    if (!document.body || window.innerWidth > 749) return;
    const main = document.querySelector('[data-template="product"], main[data-template^="product"]');
    if (!main && document.querySelector('main')?.dataset.template !== 'product') return;
    const realBtn = document.querySelector('add-to-cart-component button[name="add"]');
    if (!realBtn || document.querySelector('.pc-sticky-atc')) return;
    const title = document.querySelector('.product-title, h1')?.textContent?.trim() || '';
    const price = document.querySelector('.price__container, .price, [class*="price"]')?.textContent?.trim().split('\n')[0] || '';
    const img = document.querySelector('.product-media-container img, .product-media img, main img');
    const bar = document.createElement('div');
    bar.className = 'pc-sticky-atc';
    bar.innerHTML =
      (img ? '<img src="' + img.currentSrc + '" alt="" width="44" height="44">' : '') +
      '<span class="pc-sticky-atc__meta"><span class="pc-sticky-atc__title"></span><span class="pc-sticky-atc__price"></span></span>' +
      '<button type="button" class="pc-btn">' + (realBtn.disabled ? 'Sold out' : 'Add to bag') + '</button>';
    bar.querySelector('.pc-sticky-atc__title').textContent = title;
    bar.querySelector('.pc-sticky-atc__price').textContent = price;
    const btn = bar.querySelector('button');
    btn.disabled = realBtn.disabled;
    btn.addEventListener('click', () => {
      realBtn.click();
      btn.textContent = 'Added';
      setTimeout(() => { btn.textContent = 'Add to bag'; }, 2200);
    });
    document.body.appendChild(bar);
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => bar.classList.toggle('is-in', !e.isIntersecting && e.boundingClientRect.top < 0));
    }, { threshold: 0 });
    io.observe(realBtn);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStickyAtc);
  else initStickyAtc();
})();